export const getters = {
  reseau (state) {
  
    return state.reseau
  },
  reseaux (state) {
    return state.reseaux
  },  
  pagination(state){
    return state.pagination
  }
}
